module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mdl-grid adv-content",
    attrs: {
      "id": "page-adventure"
    }
  }, [_c('div', {
    staticClass: "adv-image-container mdl-cell mdl-cell--12-col mdl-grid"
  }, _vm._l((_vm.itemsByDate), function(item) {
    return _c('div', {
      staticClass: "mdl-cell--3-col mdl-cell--stretch mdl-card mdl-shadow--2dp "
    }, [(item.cover) ? _c('div', {
      staticClass: "mdl-card__title",
      style: ('background-image: url(' + item.cover + '); padding: 28.125% 0 28.125% 0; background-repeat: no-repeat; background-size: contain;  background-position: center;')
    }) : _c('div', {
      staticClass: "mdl-card__title",
      staticStyle: {
        "display": "inline",
        "background-color": "#ccc",
        "color": "#999",
        "font-size": "24px",
        "font-weight": "bolder",
        "height": "0px",
        "width": "100%",
        "padding": "28.125% 0 28.125% 0",
        "text-align": "center"
      }
    }, [_vm._v("\n          NO COVER\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__title"
    }, [_c('h2', {
      staticClass: "mdl-card__title-text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card_subtitle"
    }, [_vm._v("\n          By "), _c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_vm._v(_vm._s(item.owner.name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__supporting-text"
    }, [_vm._v("\n           Last Played: " + _vm._s(_vm._f("moment")(item.lastPlayed, "Do MMM YYYY")) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "mdl-card__actions mdl-card--border"
    }, [(_vm.user) ? _c('router-link', {
      staticClass: "mdl-cell--12-col-phone mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "to": ('/play/' + item.key)
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("play_arrow")]), _vm._v(" " + _vm._s(_vm.getPlayText(item.key, _vm.items)) + "\n          ")]) : _c('router-link', {
      staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
      attrs: {
        "to": "login"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("play_arrow")]), _vm._v(" Login to Play\n          ")]), _vm._v(" "), (_vm.user) ? _c('button', {
      staticClass: "mdl-cell--12-col-phone mdl-button mdl-js-button mdl-js-ripple-effect",
      on: {
        "click": function($event) {
          _vm.showDialog('shareAdventure', item.key)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("share")]), _vm._v("\n                Share\n            ")]) : _vm._e()], 1)])
  })), _vm._v(" "), _c('dialog', {
    staticClass: "mdl-dialog shareAdventure"
  }, [_c('div', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("Share this adventure")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('p', [_vm._v("\n        Share this URL with your friends:\n        "), _c('input', {
    staticClass: "mdl-textfield",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dialog_copy_text"
    },
    domProps: {
      "value": 'http://studio.adventify.com/#/play/' + _vm.selectedId
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    },
    attrs: {
      "onclick": "document.querySelector('#dialog_copy_text').select(); document.execCommand('copy'); document.querySelector('#dialog_copy_result').innerHTML = 'URL copied to clipboard!';"
    }
  }, [_vm._v("SELECT AND COPY")])]), _c('div', {
    staticStyle: {
      "position": "relative",
      "float": "left"
    },
    attrs: {
      "id": "dialog_copy_result"
    }
  }), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-dialog__actions mdl-dialog__actions"
  }, [_c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("CLOSE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-836278b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionAdventureRecentFeed.vue
// module id = 316
// module chunks = 0